<template>
  <div class="online_order_background">
    <div class="online_title">订单管理</div>
    <div class="search_area">
      <el-form ref="form" :model="onlineSearchForm" label-width="11rem">
        <el-form-item class="search_item" label="订单编号：">
          <el-input
            class="search_input"
            maxlength="22"
            placeholder="请输入订单编号"
            v-model="onlineSearchForm.code"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item class="search_item" label="产品名称：">
          <el-select
            class="search_input"
            v-model="onlineSearchForm.productId"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in productList"
              :label="item.name"
              :value="item.id"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item class="search_item" label="支付方式：">
          <el-select
            class="search_input"
            v-model="onlineSearchForm.payType"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in payTypeList"
              :label="item.name"
              :value="item.id"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item class="search_item" label="订单状态：">
          <el-select
            class="search_input"
            v-model="onlineSearchForm.status"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in orderStatusList"
              :label="item.areaName"
              :value="item.areaId"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="search_item" label="纪念堂编号：">
          <el-input
            class="search_input"
            maxlength="50"
            placeholder="请输入纪念堂编号"
            v-model.trim="onlineSearchForm.deadManCode"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item class="search_item" label="手机号：" label-width="11rem">
          <el-input
            class="search_input"
            maxlength="11"
            placeholder="请输入手机号"
            v-model="onlineSearchForm.userTel"
            @input="
              (v) => {
                this.onlineSearchForm.userTel = v.replace(/[^\d]/g, '');
              }
            "
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item class="search_item" label="支付日期：">
          <el-date-picker
            v-model="onlineSearchForm.date"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            start-placeholder="年/月/日"
            end-placeholder="年/月/日"
            :picker-options="datePickerOptions"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item class="search_item" label="退款日期：">
          <el-date-picker
            v-model="onlineSearchForm.dateBack"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            start-placeholder="年/月/日"
            end-placeholder="年/月/日"
            :picker-options="datePickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item class="search_item" label="备注：" label-width="8.2rem">
          <el-input
            class="search_input"
            maxlength="22"
            placeholder="请输入备注"
            v-model="onlineSearchForm.remark"
            clearable
          ></el-input>
        </el-form-item> -->

        <el-form-item class="search_item" label-width="3rem">
          <el-button
            class="search_button"
            type="primary"
            @click="search"
            style="background-color: #4ea2ff; border-color: #4ea2ff"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="space_list_title">
      <div class="space_list_title_item">
        <div
          :class="
            title == 0 ? 'space_list_title_text' : 'space_list_title_text_no'
          "
          style="width: 18rem; padding-left: 3rem"
          @click="changeTitle(0)"
        >
          新建订单列表
        </div>
        <div
          class="space_list_title_line"
          v-if="title == 0"
          style="left: 3rem"
        ></div>
      </div>
      <div class="space_list_title_item">
        <div
          :class="
            title == 1 ? 'space_list_title_text' : 'space_list_title_text_no'
          "
          style="width: 18rem; padding-left: 2rem"
          @click="changeTitle(1)"
        >
          续费订单列表
        </div>
        <div
          class="space_list_title_line"
          v-if="title == 1"
          style="left: 2.2rem"
        ></div>
      </div>
    </div>

    <div class="line"></div>

    <div class="table_area_total">
      <div class="user_total">
        <div>
          合计：<span class="user_total_number">{{ number }}</span>
        </div>
        <el-button
          class="btn_create right"
          @click="createdOrRenew()"
          v-if="title == 0 && pms.downCode"
          >下载新建纪念堂二维码</el-button
        >
        <el-button
          class="btn_create right"
          @click="createdOrRenew()"
          v-if="title == 1 && pms.renewCode"
          >创建续费二维码</el-button
        >
      </div>

      <div class="table_area">
        <el-table :data="totalList">
          <el-table-column
            prop="code"
            label="订单编号"
            :width="13.0 * docFontSize"
          ></el-table-column>
          <el-table-column
            prop="productName"
            label="产品名称"
            :width="22.0 * docFontSize"
          ></el-table-column>
          <!-- <el-table-column
            prop="payTypeName"
            label="支付方式"
            :width="9.0 * docFontSize"
          ></el-table-column> -->
          <!-- <el-table-column
            prop="createTime"
            label="下单时间"
            :width="12.0 * docFontSize"
          ></el-table-column> -->
          <el-table-column
            prop="payTime"
            label="支付时间"
            :width="12.0 * docFontSize"
          ></el-table-column>

          <!-- <el-table-column label="支付金额" :width="16.0 * docFontSize">
            <template slot-scope="scope">
              <div>
                <div class="v_item_name">
                  产品金额：{{ scope.row.productPrice }}
                </div>
                <div class="v_item_name" v-if="title == 1">
                  逾期金额：{{ scope.row.overdueFee }}
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column 
            prop="payAmount" 
            label="支付金额" 
            :width="16.0 * docFontSize"
          ></el-table-column>

          <el-table-column
            prop="refundTime"
            label="退款信息"
            :width="30.0 * docFontSize"
          >
            <template slot-scope="scope">
              <div>
                <div>时间：{{ scope.row.refundTime }}</div>
                <div class="v_item_name_a">
                  备注：{{ scope.row.refundRemark }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="订单关联用户信息" :width="30.0 * docFontSize">
            <template slot-scope="scope">
              <div>
                <div>付款用户手机号：{{ scope.row.userTel }}</div>
                <div>纪念堂编号：{{ scope.row.deadManCode }}</div>
                <div class="v_item_name_a">
                  纪念堂名称：{{ scope.row.deadManName }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="statusName"
            label="订单状态"
            :width="10.0 * docFontSize"
          ></el-table-column>

          <!-- <el-table-column
            prop="remark"
            label="备注"
            :width="12.0 * docFontSize"
          >
            <template slot-scope="scope">
              <div>
                <div class="v_item_name">{{ scope.row.remark }}</div>
              </div>
            </template>
          </el-table-column> -->

          <el-table-column label="操作">
            <template slot-scope="scope">
              <!-- <el-button
                type="text"
                @click="remark(scope.row)"
                v-if="pms.remark"
                >备注</el-button
              > -->
              <el-button
                type="text"
                @click="refund(scope.row)"
                v-if="pms.refund"
                :disabled="scope.row.disableRefund == 1"
                >退款</el-button
              >
              <el-button
                type="text"
                @click="showLog(scope.row.id)"
                v-if="pms.log"
                >日志</el-button
              >
            </template>
          </el-table-column>
          <template slot="empty">
            <table-empty></table-empty>
          </template>
        </el-table>
      </div>

      <div class="page_area">
        <el-pagination
          v-if="title == 0"
          :current-page.sync="pageManagement.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageManagement.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageManagement.size"
        >
        </el-pagination>

        <el-pagination
          v-if="title == 1"
          :current-page.sync="pageManagementV.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageManagementV.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageManagementV.size"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title="备注"
      width="61rem"
      :visible.sync="remarkDialog"
      :close-on-click-modal="false"
      :before-close="handleRemarkClose"
    >
      <div class="dialog_body_remark" style="margin-bottom: 3rem">
        <div class="cemetery_use">
          <div class="remark_text">备注：</div>
          <el-input
            class="search_input_big"
            type="textarea"
            v-model.trim="remarkMessage"
            :rows="4"
            resize="none"
            maxlength="30"
            placeholder="请输入备注"
          ></el-input>
          <span class="search_input_big_number_b"
            >{{ remarkMessage | remarkLength
            }}<span class="search_input_big_number_a">/30</span></span
          >
        </div>
      </div>

      <div slot="footer">
        <el-button
          style="width: 10rem; margin-right: 1.5rem"
          @click="dialogRemarkCancel()"
          class="btn_cancle_dialog"
          >取消</el-button
        >
        <el-button
          class="dialog_button"
          style="background-color: #4ea2ff; border-color: #4ea2ff"
          type="primary"
          @click="dialogRemarkSave()"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="退款"
      width="61rem"
      :visible.sync="refundDialog"
      :close-on-click-modal="false"
      :before-close="handleRefundClose"
    >
      <div class="freezeSpace">
        <div class="cemetery_use_title_b">
          <span style="color: #ff4444">*</span>请填写退款理由：
        </div>
        <el-input
          class="search_input_big"
          style="width: 24rem"
          type="textarea"
          v-model.trim="freezeRemark"
          placeholder="请输入内容"
          :rows="4"
          maxlength="100"
          resize="none"
        ></el-input>
        <span class="search_input_big_number_c"
          >{{ freezeRemark | remarkLength
          }}<span class="search_input_big_number_a">/100</span></span
        >
      </div>

      <div class="dialog_body_message" style="margin-bottom: 3rem">
        <el-input
          class="phone_message"
          maxlength="6"
          placeholder="请输入验证码"
          v-model.trim="messageClock"
          clearable
        ></el-input>
        <el-button
          class="message_to_phone"
          v-if="!timerClock"
          @click="getMessageClock"
          >获取验证码</el-button
        >
        <el-button v-else class="message_to_phone"
          >{{ totleTimeClock }}s</el-button
        >
      </div>

      <div slot="footer">
        <el-button
          style="width: 10rem; margin-right: 1.5rem"
          @click="dialogPhoneClockCancel()"
          class="btn_cancle_dialog"
          >取消</el-button
        >
        <el-button
          class="dialog_button"
          style="background-color: #4ea2ff; border-color: #4ea2ff"
          type="primary"
          @click="dialogPhoneClockSave()"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="创建续费二维码"
      width="81rem"
      :visible.sync="createRenewalLinkDialog"
      :close-on-click-modal="false"
      :before-close="handleCRLinkClose"
    >
      <div class="v_renew_title">填写需要续费的纪念堂编号：</div>
      <div class="dialog_body_message_a" style="margin-bottom: 2rem">
        <el-input
          class="phone_message"
          maxlength="50"
          placeholder="请输入续费的纪念堂编号"
          v-model.trim="renewMessage"
          clearable
        ></el-input>
        <el-button class="message_to_phone_a" @click="checkQRCode()"
          >核对纪念堂并生成二维码</el-button
        >
      </div>

      <div style="height: 6rem">
        <el-radio-group v-model="radio" @change="radioChange()">
          <el-radio label="2" style="margin-left: 1rem"
            >纪念堂续费（1年）</el-radio
          >
          <!-- <el-radio label="4" style="margin-left: 1rem"
            >纪念堂续费（30年）</el-radio
          > -->
        </el-radio-group>
      </div>

      <div class="v_renew_content" v-if="isHaveNoBac">
        <div class="v_renew_content_text">纪念堂封面：</div>
        <div class="v_text_img">
          <img
            class="iv_have_bac"
            src="@/assets/images/space/default_photo.png"
            alt=""
            v-if="imgUrl == ''"
          />
          <img v-if="imgUrl != ''" class="iv_have_bac" :src="imgUrl" alt="" />
        </div>
        <div>
          <div class="v_renew_content_right">
            <div class="v_renew_content_text">纪念堂名称：</div>
            <div>{{ spaceName }}</div>
          </div>
          <div class="v_renew_content_right" style="margin-top: 2rem">
            <div class="v_renew_content_text">纪念堂状态：</div>
            <div>{{ spaceState }}</div>
            <div style="color: rgb(255, 74, 36); margin-left: 1rem">
              {{ spaceStateClock }}
            </div>
          </div>
        </div>
      </div>

      <div class="v_renew_down" v-if="isHaveNoBac">
        <div class="v_renew_down_link">二维码地址：</div>
        <img class="iv_have_bac_code" :src="qrCodeLink" alt="" />
        <el-button
          :type="!isHaveNoBac || isCanClick ? 'info' : 'primary'"
          :disabled="!isHaveNoBac || isCanClick"
          @click="getDownQR()"
          >下载二维码</el-button
        >
      </div>

      <div slot="footer">
        <el-button
          style="width: 10rem; margin-right: 1.5rem"
          @click="renewalLinkCancel()"
          class="btn_cancle_dialog"
          >取消</el-button
        >
      </div>
    </el-dialog>

    <el-drawer
      title="日志"
      :visible.sync="tableLog"
      direction="rtl"
      :size="drawarWidth"
      custom-class="drawer_change"
      :before-close="handleClose"
      :wrapperClosable="false"
    >
      <div class="search_area_log_middle">
        <div class="search_area_log">
          <el-form ref="form" :model="onlineSearchFormLog" label-width="11rem">
            <el-form-item class="search_item" label="操作员：">
              <el-input
                class="search_input"
                maxlength="60"
                placeholder="请输入操作员名称"
                v-model="onlineSearchFormLog.createUserName"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item
              class="search_item"
              label="操作内容："
              label-width="11rem"
            >
              <el-input
                class="search_input"
                maxlength="60"
                placeholder="请输入操作内容"
                v-model="onlineSearchFormLog.content"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item class="search_item" label="操作日期：">
              <el-date-picker
                v-model="onlineSearchFormLog.date"
                type="daterange"
                range-separator="-"
                value-format="yyyy-MM-dd"
                start-placeholder="年/月/日"
                end-placeholder="年/月/日"
                :picker-options="datePickerOptions"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item class="search_item" label-width="5.5rem">
              <el-button
                class="search_button"
                type="primary"
                @click="searchLog()"
                style="
                  background-color: #4ea2ff;
                  border-color: #4ea2ff;
                  margin-left: 50rem;
                "
                >查询</el-button
              >
            </el-form-item>
          </el-form>
        </div>

        <div class="table_area_log_all">
          <div class="log_number_all">
            合计：<span class="log_number_blue">{{ numberLog }}</span>
          </div>

          <div class="table_area_log">
            <el-table :data="logList">
              <el-table-column
                prop="index"
                label="序号"
                :width="20.0 * docFontSize"
              ></el-table-column>
              <el-table-column label="操作员信息" :width="30.0 * docFontSize">
                <template slot-scope="scope">
                  <div>
                    <div class="v_item_name" v-if="scope.row.unitShortName">
                      单位简称：{{ scope.row.unitShortName }}
                    </div>
                    <div class="v_item_name">
                      账号：{{ scope.row.createUserName }}
                    </div>
                    <div class="v_item_name" v-if="scope.row.createUserNick">
                      使用者：{{ scope.row.createUserNick }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="content"
                label="操作内容"
                :width="30.0 * docFontSize"
              ></el-table-column>
              <el-table-column prop="createTime" label="操作日期">
              </el-table-column>
              <template slot="empty">
                <table-empty></table-empty>
              </template>
            </el-table>
          </div>
          <div class="page_area">
            <el-pagination
              :current-page.sync="pageManagementLog.page"
              layout="total, prev, pager, next, jumper"
              :total="pageManagementLog.total"
              @current-change="handleCurrentChangeLog"
              :page-size="10"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import mixin from "./Mixins";
import TableEmpty from "../../../../components/TableEmpty.vue";
import { _payRefundSendCode } from "@/api/Common";
import { catchErr, nowDate } from "@/utils/utils";
import axios from "axios";
export default {
  components: { TableEmpty },
  mixins: [mixin],
  data() {
    return {
      datePickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() ||
            time.getTime() < new Date("2021-01-01")
          );
        },
      },
      remarkDialog: false,
      remarkMessage: "",
      tableLog: false,
      pms: {
        remark: false,
        log: false,
        refund: false,
        downCode: false,
        renewCode: false,
      },
      remarkId: "",

      refundId: "",
      refundDialog: false,

      freezeRemark: "",
      messageClock: "",
      timerClock: null,
      totleTimeClock: 60,

      orderId: "",
      createRenewalLinkDialog: false,
      isHaveNoBac: false,
      radio: "2",
      renewMessage: "",
      imgUrl: "",
      spaceName: "",
      spaceState: "",
      spaceStateClock: "",
      isCanClick: true,
      qrCodeLink: "",
    };
  },
  computed: {
    title: {
      get: function () {
        return this.OnlineOrder.onlineOrder.title;
      },
      set: function (v) {
        this.SETTITLE(v);
      },
    },
    numberLog: {
      get: function () {
        return this.OnlineOrder.onlineOrder.numberLog;
      },
      set: function (v) {
        this.SETLOGNUMBER(v);
      },
    },
    drawarWidth() {
      let result = 130.0 * this.docFontSize;
      let percent = (result / document.body.clientWidth) * 100;
      return `${percent}%`;
    },
    number: {
      get: function () {
        return this.OnlineOrder.onlineOrder.number;
      },
    },
    onlineSearchForm() {
      return this.OnlineOrder.onlineOrder.onlineSearchForm;
    },
    onlineSearchFormLog() {
      return this.OnlineOrder.onlineOrder.onlineSearchFormLog;
    },
    productList() {
      return this.OnlineOrder.onlineOrder.productList;
    },
    payTypeList() {
      return this.OnlineOrder.onlineOrder.payTypeList;
    },
    orderStatusList() {
      return this.OnlineOrder.onlineOrder.orderStatusList;
    },
    totalList() {
      return this.OnlineOrder.onlineOrder.totalList;
    },
    logList() {
      return this.OnlineOrder.onlineOrder.logList;
    },
    pageManagement() {
      return this.OnlineOrder.onlineOrder.pageManagement;
    },
    pageManagementV() {
      return this.OnlineOrder.onlineOrder.pageManagementV;
    },
    pageManagementLog() {
      return this.OnlineOrder.onlineOrder.pageManagementLog;
    },
  },
  filters: {
    remarkLength(v) {
      if (v) {
        return v.length;
      } else {
        return 0;
      }
    },
  },
  created() {
    //处理返回键
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", function () {
      history.pushState(null, null, document.URL);
    });

    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"));
    this.pms.remark = pms["70200"].check;
    this.pms.log = pms["70400"].check;
    this.pms.refund = pms["70300"].check;
    this.pms.downCode = pms["70500"].check;
    this.pms.renewCode = pms["70600"].check;

    this.findOrderList();
    this.findProduct();
    this.findPayType();
  },
  mounted() {
    this.setLeftMenuShow_M(true);
    this.setLeftMenuIndex_M(6);
  },
  methods: {
    //切换
    changeTitle(v) {
      this.title = v;
      this.findOrderList();
    },
    handleCurrentChangeLog(v) {
      let params = {
        orderId: this.orderId,
      };
      this.findOrderLog(params);
    },
    async getMessageClock() {
      let data = this.refundId;
      let [err, res] = await catchErr(
        _payRefundSendCode({
          data: data,
        })
      );
      if (err) {
        if (err.status == 1047) {
          this.$message.error("未关联手机号");
          return;
        }
        this.$message.error(err.message || "发送失败");
      } else {
        this.$message.success("发送成功");
        this.timerClock = window.setInterval(() => {
          this.totleTimeClock--;
          if (this.totleTimeClock <= 0) {
            window.clearInterval(this.timerClock);
            this.timerClock = null;
            this.totleTimeClock = 60;
          }
        }, 1000);
      }
    },
    handleRefundClose(done) {
      this.messageClock = "";
      window.clearInterval(this.timerClock);
      this.timerClock = null;
      this.totleTimeClock = 60;
      this.refundId = "";
      this.freezeRemark = "";
      done();
    },

    dialogPhoneClockCancel() {
      this.refundDialog = false;
      this.messageClock = "";
      window.clearInterval(this.timerClock);
      this.timerClock = null;
      this.totleTimeClock = 60;
      this.refundId = "";
      this.freezeRemark = "";
    },

    dialogPhoneClockSave() {
      if (this.freezeRemark == "") {
        this.$message.error("请输入退款理由");
        return;
      }
      if (this.messageClock == "") {
        this.$message.error("请输入验证码");
        return;
      }
      let params = {
        orderId: this.refundId,
        code: this.messageClock,
        remark: this.freezeRemark,
      };
      this.payRefund(params).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          this.messageClock = "";
          this.freezeRemark = "";
          this.$message.success("退款成功");
          window.clearInterval(this.timerClock);
          this.timerClock = null;
          this.totleTimeClock = 60;
          this.findOrderList();
          this.refundDialog = false;
        } else if (res.status == 1018) {
          this.$message.error("验证码不正确，请输入正确的验证码");
        } else if (res.status == 1019) {
          this.$message.error("验证码不正确，请输入正确的验证码");
        } else if (res.status == 1001) {
          this.$message.error("基本账户余额不足，请充值后重新发起");
        } else {
          this.$message.error(res.message || "系统异常");
        }
      });
    },

    search() {
      if (this.title == 0) {
        this.OnlineOrder.onlineOrder.pageManagement.page = 1;
      } else {
        this.OnlineOrder.onlineOrder.pageManagementV.page = 1;
      }
      this.findOrderList();
    },
    searchLog() {
      let params = {
        orderId: this.orderId,
      };
      this.findOrderLog(params);
    },
    handleSizeChange(v) {
      console.log(v);
      if (this.title == 0) {
        this.OnlineOrder.onlineOrder.pageManagement.size = v;
      } else {
        this.OnlineOrder.onlineOrder.pageManagementV.size = v;
      }
      this.findOrderList();
    },
    handleCurrentChange(v) {
      console.log(v);
      this.findOrderList();
    },
    refund(v) {
      this.refundId = v.id;
      this.refundDialog = true;
    },
    remark(v) {
      this.remarkId = v.id;
      if (v.remark != "—") {
        this.remarkMessage = v.remark;
      } else {
        this.remarkMessage = "";
      }
      this.remarkDialog = true;
    },
    showLog(v) {
      this.orderId = v;
      this.tableLog = true;
      let params = {
        orderId: v,
      };
      this.findOrderLog(params);
    },
    handleRemarkClose(done) {
      this.remarkMessage = "";
      this.remarkId = "";
      done();
    },
    dialogRemarkCancel() {
      this.remarkMessage = "";
      this.remarkId = "";
      this.remarkDialog = false;
    },
    dialogRemarkSave() {
      let data = {
        id: this.remarkId,
        remark: this.remarkMessage,
      };
      this.addRemark(data).then((res) => {
        if (res) {
          this.$message.success("操作成功");
          this.remarkMessage = "";
          this.remarkId = "";
          this.findOrderList();
          this.remarkDialog = false;
        }
      });
    },

    handleClose(done) {
      this.OnlineOrder.onlineOrder.onlineSearchFormLog = {
        createUserName: "",
        content: "",
        date: "",
      };
      this.OnlineOrder.onlineOrder.logList = [""];
      this.OnlineOrder.onlineOrder.numberLog = "";
      this.OnlineOrder.onlineOrder.pageManagementLog = {
        page: 1,
        size: 10,
        total: 0,
      };
      done();
    },

    /**
     * 下载新建纪念堂二维码
     * 创建续费二维码
     */
    createdOrRenew() {
      if (this.title == 0) {
        this.getPurchaseQRCode().then((res) => {
          console.log(res);
          if (res.status == 1000) {
            let link = document.createElement("a");
            let name = "新建纪念堂";
            axios({
              method: "POST",
              url: "/api/common/getUrlDataSource",
              data: {
                data: res.data,
              },
              responseType: "blob",
            }).then((response) => {
              link.href = URL.createObjectURL(response.data);
              name = name + nowDate.getNowDate() + ".png";
              console.log(name);
              link.download = name;
              document.body.appendChild(link);
              link.click();
            });
          }
        });
      } else {
        this.createRenewalLinkDialog = true;
      }
    },
    renewalLinkCancel() {
      this.isHaveNoBac = false;
      this.imgUrl = "";
      this.spaceName = "";
      this.spaceState = "";
      this.isCanClick = true;
      this.spaceStateClock = "";
      this.qrCodeLink = "";
      this.renewMessage = "";
      this.radio = "2";
      this.createRenewalLinkDialog = false;
    },
    handleCRLinkClose(done) {
      this.isHaveNoBac = false;
      this.imgUrl = "";
      this.spaceName = "";
      this.spaceState = "";
      this.spaceStateClock = "";
      this.isCanClick = true;
      this.qrCodeLink = "";
      this.renewMessage = "";
      this.radio = "2";
      done();
    },
    radioChange() {
      console.log(this.radio);
      if (this.isHaveNoBac) {
        this.isHaveNoBac = false;
        this.checkQRCode();
      }
    },
    checkQRCode() {
      if (this.renewMessage == "") {
        this.$message.error("请填写需要续费的纪念堂编号");
        this.isHaveNoBac = false;
        this.imgUrl = "";
        this.spaceName = "";
        this.spaceState = "";
        this.spaceStateClock = "";
        this.isCanClick = true;
        this.qrCodeLink = "";
        return;
      }
      let params = {
        code: this.renewMessage,
        productId: this.radio,
      };
      this.getRenewQRCode(params).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          this.isHaveNoBac = true;
          this.imgUrl = res.data.deadManCoverUrl;
          this.spaceName = res.data.deadManName;
          if (res.data.foreverState == 1) {
            this.spaceState = "永久";
            this.isCanClick = true;
          } else {
            if (res.data.status == 2) {
              this.spaceState = "过期";
              if (res.data.renewState == 1) {
                this.isCanClick = false;
              } else {
                this.isCanClick = true;
              }
            } else {
              if (res.data.closeTimeState == 1) {
                this.spaceState = "即将到期";
                if (res.data.renewState == 1) {
                  this.isCanClick = false;
                } else {
                  this.isCanClick = true;
                }
              } else if (res.data.status == 1) {
                this.spaceState = "有效";
                if (res.data.renewState == 1) {
                  this.isCanClick = false;
                } else {
                  this.isCanClick = true;
                }
              }
            }
          }
          if (res.data.spaceFrozen == 1) {
            this.spaceStateClock = "已冻结";
          }
          this.qrCodeLink = res.data.qrcodeUrl;
        } else if (res.status == 1076) {
          this.$message.error("无此纪念堂");
          this.isHaveNoBac = false;
          this.imgUrl = "";
          this.spaceName = "";
          this.spaceState = "";
          this.spaceStateClock = "";
          this.isCanClick = true;
          this.qrCodeLink = "";
          return;
        }
      });
    },
    //下载续费二维码
    getDownQR() {
      let link = document.createElement("a");
      let name = "续费-";
      if (this.spaceName.length > 6) {
        name = name + this.spaceName.substring(0, 6);
      } else {
        name = name + this.spaceName;
      }
      axios({
        method: "POST",
        url: "/api/common/getUrlDataSource",
        data: {
          data: this.qrCodeLink,
        },
        responseType: "blob",
      }).then((response) => {
        link.href = URL.createObjectURL(response.data);
        name = name + nowDate.getNowDate() + ".png";
        console.log(name);
        link.download = name;
        document.body.appendChild(link);
        link.click();
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.online_order_background {
  width: 100%;
  height: 100%;
  background: #FFFFFF;

  .online_title {
    height: 70px;
    line-height: 70px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    padding-left: 30px;
    border-bottom: 1px solid #E9ECF3;
  }

  .search_area {
    margin-top: 20px;
    width: 100%;
    border-bottom: 1px solid #E9ECF3;
    height: 124px;
  }

  .search_item {
    float: left;
    height: 40px;
  }

  .search_item >>>.el-form-item__label {
    color: #040300;
  }

  .search_input >>>.el-input__inner {
    width: 220px;
  }

  .search_button {
    width: 100px;
  }

  .user_total {
    margin-left: 30px;
    margin-right: 30px;
    height: 62px;
    line-height: 62px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .user_total_number {
    font-size: 16px;
    font-weight: 500;
    color: #2C90FF;
  }

  .table_area_total {
    background-color: #fff;
    position: absolute;
    left: 3rem;
    bottom: 0;
    right: 3rem;
    top: 32rem;
    overflow: auto;
  }

  .table_area >>>.el-table__header thead {
    tr, th {
      background-color: #F7FAFF;
    }
  }

  .table_area {
    margin-left: 30px;
    margin-right: 30px;
  }

  .table_area >>> .cell {
    margin-left: 20px;
  }

  .page_area {
    padding-top: 15px;
  }

  .page_area >>> .el-input__inner {
    border: 1px solid #DCDFE6;
  }

  .page_area {
    height: 30px;
    padding-top: 35px;
    padding-bottom: 15px;

    .el-pagination {
      text-align: center;
    }

    .el-pagination__total {
      color: #333333;
      font-size: 12px;
    }
  }

  .dialog_body_remark {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .cemetery_use {
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
  }

  .remark_text {
    margin-top: 5px;
    color: #000000;
  }

  .search_input_big_number_b {
    position: absolute;
    right: 8px;
    bottom: 8px;
    color: #2C90FF;
    font-size: 14px;
    background: #fff;
  }

  .search_input_big_number_c {
    position: absolute;
    right: 120px;
    bottom: 8px;
    color: #2C90FF;
    font-size: 14px;
    background: #fff;
  }

  .search_input_big_number_a {
    color: #000000;
    font-size: 14px;
  }

  .search_input_big {
    width: 220px;
    margin-left: 10px;
  }

  .search_input_big >>> .el-textarea__inner {
    font-family: 'Microsoft Yahei', '微软雅黑', Arial, sans-serif;
    color: #000000;
    border-radius: 0;
  }

  .btn_cancle_dialog {
    border: 1px solid #2C90FF;
    color: #2C90FF;
  }

  .search_area_log {
    margin-left: 30px;
    width: 1210px;
    border: 1px solid #CCD7EA;
    height: 124px;
    padding-top: 20px;
  }

  .search_area_log_middle {
    overflow: auto;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 80px;
  }

  .log_number_all {
    height: 62px;
    line-height: 62px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    margin-left: 30px;
  }

  .log_number_blue {
    font-size: 16px;
    font-weight: 500;
    color: #2C90FF;
  }

  .table_area_log >>> .cell {
    margin-left: 80px;
  }

  .table_area_log_all {
    background-color: #fff;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 1210px;
    // right: 0;
    top: 15.6rem;
    overflow: auto;
    margin-left: 30px;
  }

  .table_area_log {
    // margin-left: 30px;
    // width: 1210px;
  }

  .v_item_name {
    max-width: 190px;
    overflow: hidden; // 超出部分隐藏
    text-overflow: ellipsis; // 隐藏部分用...代替
    white-space: nowrap;
  }

  .v_item_name_a {
    max-width: 250px;
    overflow: hidden; // 超出部分隐藏
    text-overflow: ellipsis; // 隐藏部分用...代替
    white-space: nowrap;
  }

  .freezeSpace {
    margin-bottom: 30px;
    display: flex;
    position: relative;
    justify-content: center;
  }

  .cemetery_use_title_b {
    width: 120px;
  }

  .dialog_body_message {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 100px;
    // justify-content: center;
  }

  .v_renew_title {
    margin-left: 10px;
    color: #000000;
    height: 40px;
    line-height: 40px;
  }

  .dialog_body_message_a {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 10px;
    // justify-content: center;
  }

  .v_renew_content {
    display: flex;
    flex-direction: row;
    margin-left: 10px;
    color: #000000;
    margin-bottom: 20px;
  }

  .v_renew_content_text {
    flex-shrink: 0;
  }

  .v_renew_content_right {
    display: flex;
    flex-direction: row;
  }

  .v_renew_down {
    display: flex;
    flex-direction: row;
    margin-left: 10px;
    color: #000000;
    align-items: center;
    margin-bottom: 20px;
  }

  .v_renew_down_link {
    color: #000000;
  }

  .v_text_img {
    width: 220px;
    height: 96px;
  }

  .iv_have_bac {
    width: 72px;
    height: 96px;
    flex-shrink: 0;
  }

  .iv_have_bac_code {
    width: 150px;
    height: 150px;
    margin-right: 30px;
  }

  .phone_message {
    margin-right: 30px;
    width: 230px;
  }

  .message_to_phone {
    color: #FFFFFF;
    background: #F66915;
    border: 1px solid #F66915;
    width: 180px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    padding: 0;
  }

  .message_to_phone_a {
    color: #FFFFFF;
    background: #2c90ff;
    border: 1px solid #2c90ff;
    width: 180px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    padding: 0;
  }

  .space_list_title {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 70px;
    line-height: 70px;
  }

  .space_list_title_item {
    position: relative;
    height: 70px;
    line-height: 70px;
    cursor: pointer;
  }

  .space_list_title_text {
    height: 70px;
    line-height: 70px;
    font-size: 20px;
    font-weight: 500;
    color: #2C90FF;
    box-sizing: border-box;
  }

  .space_list_title_text_no {
    font-size: 14px;
    font-weight: 500;
    color: #000000;
    box-sizing: border-box;
  }

  .space_list_title_line {
    position: absolute;
    bottom: 0;
    width: 40px;
    height: 4px;
    background: #2C90FF;
  }

  .line {
    margin-left: 30px;
    width: 1532px;
    height: 1px;
    background: #CCD7EA;
  }

  .btn_create {
    background-color: #2C90FF;
    width: 200px;
    height: 40px;
    color: #fff;
    padding: 0 20px;
    float: right;

    .btn_content {
      display: flex;
      align-items: center;
    }

    .text_create {
      display: inline-block;
    }
  }
}
</style>

<style lang="stylus">
.drawer_change .el-drawer__header {
  font-size: 34px;
  font-weight: 500;
  color: #000000;
}

.drawer_change .el-drawer__close-btn {
  font-size: 30px;
}
</style>


// WEBPACK FOOTER //
// src/pages/PartII/OnlineOrder/components/OnlineOrder.vue